import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import Stack from "@components/Stack";
import { Link, navigate } from "gatsby";
import WelcomeForm from "@components/WelcomeScreen/WelcomeForm";
// @ts-ignore
import becoming from '../../assets/becoming.png';
// @ts-ignore
import rocketShip from '../../assets/business-startup.png';
// @ts-ignore
import logo from '../../assets/Okay-Human.png';

function WelcomeScreen() {
  return (
    <WelcomeScreenWrapper>
      <LeftWrapper type="column" gap={0}>
        <Row>
          <ContentBox>
            <SymplerLogoContainer to="https://okayhuman.com">
              {/* <SymplerLogo /> */}
              <MobileImage>
                <RocketImage />
              </MobileImage>
              <div style={{maxWidth: '370px'}}>
                <BecomingImage />
                <TopTextTag>formerly sympler</TopTextTag>
              </div>
            </SymplerLogoContainer>
          </ContentBox>
          <DesktopImage>
            <div>
              <RocketImage />
            </div>
          </DesktopImage>
        </Row>
          <TopText>Okay human, let's start a conversation.</TopText>
      </LeftWrapper>

      <RightWrapper type="column" gap={0} stretchColumns>
        <WelcomeForm />
      </RightWrapper>
    </WelcomeScreenWrapper>
  );
}

export default WelcomeScreen;

const DesktopImage = styled.div`
  display: none;
  @media(min-width: 720px){
    position: relative;
    display: block;
  }`

const MobileImage = styled.div`
  display: block;
  position: absolute;
  top: 0;
  left: 85px;
  overflow: none;
  z-index: -1;
  @media(min-width: 720px) {
    display: none;
  }
`

const WelcomeScreenWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: min-content;
  /* grid-gap: 6rem; */
  width: 100%;
  position: relative;
  z-index: 3;
  place-content: center;
  /* border: 4px solid red; */
  /* padding: 12rem 0; */

  @media (max-width: 950px) {
    grid-template-columns: 1fr;
    grid-gap: 4rem;
  }
`;

const ContentBox = styled.div`
  @media (min-width: 720px) {
    width: 470px;
    margin-bottom: 100px;
  }`

const Row = styled(Stack)`
  @media (min-width: 720px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }
`

const LeftWrapper = styled(Stack)`
  justify-content: center;
  /* border: 2px solid blue; */
  align-self: center;
`;

const RightWrapper = styled(Stack)`
  margin: 0 auto;
  place-content: center;
  width: 400px;

  /* border: 2px solid green; */

  @media (max-width: 950px) {
    width: 100%;
    /* padding: calc(var(--top-amount) * 1.15) 0 var(--top-amount) 0; */
  }
`;

const AvatarContainer = styled(motion.div)`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const InterfaceText = styled(motion.div)`
  border-radius: 1rem;
  /* padding: 2rem; */
  position: relative;
  /* box-shadow: 0 1px 2px rgba(99, 94, 192, 0.15); */
  color: #132142;
  font-weight: 100;
  font-size: clamp(3rem, 5vw, 3.2rem);
  letter-spacing: 0.25px;
  line-height: 1;
  position: relative;
  z-index: 2;
  font-family: "Catamaran";
  max-width: 700px;

  @media (max-width: 950px) {
    width: auto;
  }
`;

const RegularText = styled.p`
  border-radius: 1rem;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.3);
  mix-blend-mode: multiply;
  position: relative;
  box-shadow: 0 1px 2px rgba(99, 94, 192, 0.15);
  color: #132142;
  font-weight: 200;
  font-size: clamp(1.85rem, 5vw, 2.1rem);
  letter-spacing: 0.25px;
  line-height: 1;
  font-family: "Catamaran";
`;

const TopText = styled.div`
  font-size: clamp(3.1rem, 5vw, 3.3rem);
  font-weight: 400;
  color: #132142;
  line-height: 1;
  margin-top: 60px;
  text-align: center;
  @media(min-width: 720px) {
    position: absolute;
    bottom: 20px;
    margin-top: 0px;
  }
`;

const TopTextTag = styled.div`
  margin-top: 45px;
  text-align: center;
  font-size: clamp(3.1rem, 5vw, 3.3rem);
  font-weight: 400;
  color: #132142;
  line-height: 1;
  font-style: italic;
`;

const MiddleText = styled.h2`
  font-weight: 300;
  line-height: 1;
  color: #132142;
  margin-top: 2rem;
`;

const SmallText = styled.p`
  color: #635ec0;
  font-size: 1.45rem;
  letter-spacing: 0.25px;
  cursor: pointer;
  text-align: center;
`;

const InstructionText = styled(motion.p)`
  /* position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 200%); */
  color: #1f2021;
  letter-spacing: 0.5px;
  font-size: 1.25rem;
  display: flex;
  margin: 0 auto;
  align-items: center;
  text-align: center;
  justify-content: center;
`;

const KeyboardText = styled.kbd`
  color: white;
  background: #635ec0;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  text-transform: uppercase;
  font-size: 0.9rem;
  margin: 0 1ch;
`;
// height: 15rem;
const SymplerLogoContainer = styled(Link)`
  height: 100%;

  svg {
    height: 100%;
  }
`;

const StyledBecomingImage = styled.img`
  max-width: 100%;
  height: auto;
`;

const StyledRocketImage = styled.img`
  height: auto;
  transform: rotate(20deg);
  opacity: .4;
  @media(min-width: 720px) {
    margin-top: 100px;
    opacity: 1;
  }
`;

const BecomingImage = () => (
  <StyledBecomingImage src={logo} alt="Okay Human Logo"/>
);

const RocketImage = () => (
  <StyledRocketImage src={rocketShip} alt="Rocket Ship" />
);

function SymplerLogo() {
  return (
    <svg viewBox="0 0 352 83" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.48 44.595c-2.32-16.302-16.522-28.592-33.044-28.592-4.249 0-8.362.777-12.203 2.285-.427.167-.242.863.217.863 1.122 0 2.24.12 3.325.355 5.983 1.297 9.093 6.877 9.293 7.247l16.58 28.67c1.53 2.646 4.464 4.416 7.332 3.36 1.567-.577 3.226-1.506 4.588-3.003 4.302-4.729 3.936-10.86 3.912-11.185z"
        fill="url(#p0l)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.497 20.881a14.372 14.372 0 00-3.029-.32c-4.783 0-8.407 2.354-8.668 2.528C4.665 29.457 0 39.007 0 49.293c0 9.216 3.74 17.732 10.082 23.87.742.718 2.117-.488 1.8-1.471-1.877-5.836 1.442-11.328 1.648-11.66l16.608-28.62c1.55-2.669 1.605-6.131-.778-8.093-1.285-1.057-2.912-2.016-4.863-2.438z"
        fill="url(#p1l)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.57 56.817c-3.823 4.192-9.654 4.404-10.784 4.405-.093 0-.149-.002-.163-.002H19.472c-3.068 0-6.075 1.667-6.592 4.69-.28 1.637-.304 3.522.305 5.417 1.988 6.187 7.704 8.937 7.762 8.965l.064.03a33.337 33.337 0 0012.345 2.348c15.562 0 28.671-10.655 32.36-25.025.254-.994-1.455-1.585-2.146-.828z"
        fill="url(#p2l)"
      />
      <path
        d="M116.217 35.457l-2.929 3.027c-2.431-2.365-4.807-3.548-7.129-3.548-1.476 0-2.745.489-3.809 1.465-1.041.977-1.562 2.116-1.562 3.418 0 1.15.434 2.246 1.302 3.288.868 1.063 2.691 2.311 5.469 3.743 3.385 1.758 5.685 3.45 6.901 5.078 1.193 1.65 1.79 3.505 1.79 5.567 0 2.908-1.02 5.37-3.06 7.39-2.04 2.017-4.59 3.026-7.65 3.026-2.04 0-3.993-.444-5.86-1.334-1.844-.89-3.374-2.116-4.589-3.679l2.865-3.255c2.322 2.626 4.785 3.939 7.389 3.939 1.823 0 3.375-.586 4.655-1.758 1.28-1.172 1.92-2.55 1.92-4.134 0-1.302-.423-2.463-1.269-3.483-.846-.998-2.756-2.257-5.729-3.776-3.19-1.65-5.36-3.277-6.51-4.883-1.15-1.606-1.726-3.44-1.726-5.501 0-2.691.912-4.926 2.734-6.706 1.845-1.78 4.167-2.67 6.967-2.67 3.255 0 6.532 1.596 9.83 4.786zm5.964-3.874h4.818l12.174 27.279 11.817-27.279h4.85l-21.127 48.373h-4.817l6.836-15.625-14.551-32.748zm41.185 0h4.525v6.12c1.584-2.257 3.211-3.906 4.882-4.948 2.301-1.389 4.72-2.083 7.259-2.083 1.715 0 3.343.336 4.883 1.009 1.541.673 2.8 1.573 3.776 2.702.977 1.107 1.823 2.702 2.539 4.785 1.52-2.778 3.418-4.883 5.697-6.315 2.279-1.454 4.731-2.181 7.357-2.181 2.452 0 4.611.618 6.478 1.855 1.888 1.237 3.287 2.963 4.199 5.176.911 2.214 1.367 5.534 1.367 9.961V67h-4.655V47.664c0-3.798-.271-6.402-.814-7.812-.542-1.433-1.475-2.583-2.799-3.451-1.302-.868-2.865-1.302-4.688-1.302-2.213 0-4.242.651-6.087 1.953-1.823 1.302-3.157 3.038-4.004 5.208-.846 2.17-1.269 5.795-1.269 10.873V67h-4.525V48.868c0-4.275-.271-7.172-.814-8.69-.521-1.542-1.443-2.768-2.767-3.68-1.324-.932-2.897-1.4-4.72-1.4-2.105 0-4.08.641-5.924 1.922-1.823 1.258-3.18 2.962-4.069 5.11-.868 2.149-1.302 5.436-1.302 9.863V67h-4.525V31.583zm64.329 0h4.525v6.51c1.801-2.473 3.874-4.329 6.217-5.566 2.344-1.237 4.959-1.855 7.846-1.855 5.034 0 9.342 1.812 12.923 5.436 3.58 3.624 5.371 7.986 5.371 13.086 0 5.208-1.78 9.635-5.339 13.281-3.537 3.624-7.812 5.437-12.825 5.437-2.821 0-5.415-.587-7.78-1.758-2.366-1.172-4.503-2.92-6.413-5.241v19.043h-4.525V31.583zm18.229 3.483c-3.949 0-7.28 1.378-9.993 4.134-2.691 2.757-4.037 6.185-4.037 10.287 0 2.69.597 5.11 1.791 7.26 1.215 2.148 2.94 3.851 5.176 5.11 2.257 1.258 4.633 1.888 7.129 1.888 2.452 0 4.752-.63 6.901-1.888 2.17-1.28 3.895-3.06 5.175-5.339 1.281-2.278 1.921-4.666 1.921-7.161 0-2.518-.64-4.905-1.921-7.162-1.258-2.257-2.962-4.004-5.11-5.24-2.149-1.26-4.492-1.889-7.032-1.889zm28.197-17.155h4.557V67h-4.557V17.911zm45.514 37.338l3.842 2.018c-1.259 2.474-2.713 4.47-4.362 5.99a17.566 17.566 0 01-5.567 3.483c-2.061.78-4.394 1.172-6.999 1.172-5.772 0-10.286-1.889-13.541-5.665-3.255-3.797-4.883-8.083-4.883-12.858 0-4.492 1.378-8.496 4.134-12.011 3.494-4.47 8.171-6.706 14.03-6.706 6.033 0 10.851 2.29 14.453 6.868 2.561 3.234 3.863 7.27 3.906 12.11h-31.836c.087 4.123 1.4 7.508 3.939 10.156 2.539 2.626 5.675 3.939 9.408 3.939 1.801 0 3.548-.315 5.241-.944 1.714-.63 3.168-1.465 4.362-2.507 1.193-1.041 2.485-2.723 3.873-5.045zm0-9.538c-.607-2.43-1.497-4.373-2.669-5.827-1.15-1.454-2.68-2.626-4.59-3.516a14.09 14.09 0 00-6.022-1.334c-3.472 0-6.456 1.117-8.952 3.353-1.823 1.627-3.201 4.069-4.134 7.324h26.367zm13.483-14.128h4.655v5.176c1.389-2.04 2.854-3.559 4.395-4.557 1.541-1.02 3.147-1.53 4.818-1.53 1.258 0 2.604.401 4.036 1.204l-2.376 3.841c-.955-.412-1.758-.618-2.409-.618-1.519 0-2.984.63-4.395 1.888-1.41 1.237-2.484 3.168-3.222 5.794-.564 2.019-.847 6.098-.847 12.24V67h-4.655V31.583z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="p0l"
          x1={18.7819}
          y1={53.3271}
          x2={66.4976}
          y2={53.3271}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7ECEFD" />
          <stop offset={1} stopColor="#9EBDFF" />
        </linearGradient>
        <linearGradient
          id="p1l"
          x1={10.0713}
          y1={26.1918}
          x2={29.9611}
          y2={72.3083}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FC7D49" />
          <stop offset={1} stopColor="#FF788D" />
        </linearGradient>
        <linearGradient
          id="p2l"
          x1={58.3158}
          y1={56.073}
          x2={18.1172}
          y2={80.5921}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1A5F6" />
          <stop offset={1} stopColor="#FC89CB" />
        </linearGradient>
      </defs>
    </svg>
  );
}
